<script setup>
import { computed, watch } from 'vue';
import IEventItem from '@components/IEventItem/IEventItem.vue';
import { translator } from '@shop/frontend/web/js/services/TranslatorService';
import EventsItemsEmpty from './EventsItemsEmpty.vue';
import EventItemsSkeleton from './EventItemsSkeleton.vue';
import useSiteStore from '../../store/modules/site.js';

const store = useSiteStore();
store.searchSubscriptions();

const loadingData = computed(
  () => store.getSubscriptionsState.loading,
);

const showSubscriptions = computed(
  () => !!store.getSubscriptionsState.items.length
      && (!store.getSelectTypes.items.length || store.getSelectTypes.items.includes(2)),
);

watch(loadingData, () => (loadingData.value ? $('#js-overlay').show() : $('#js-overlay').hide()));
</script>

<template>
  <event-items-skeleton :is-data-loading="loadingData">
    <events-items-empty>
      <div v-if="showSubscriptions" class="event-item">
				<h3 class="event-item__title mt-0" data-test-id="season_tickets_title">
					{{ translator.t("main", "Season tickets") }}
				</h3>
				<i-event-item v-for="event in store.getSubscriptionsState.items" :key="event.id"
					:event="event"></i-event-item>
				<div v-if="store.getSubscriptionsState.showLoadMore" class="text-center">
					<button class="btn btn_border" data-test-id="season_tickets_load_btn"
						@click="store.loadMoreSubscriptions">
						{{ translator.t("main", "More") }}
					</button>
				</div>
			</div>
    </events-items-empty>
  </event-items-skeleton>
</template>

<style lang="scss">

</style>
